<template>
    <v-container
      class="fill-height py-0"
      fluid>
        <v-row
            align="center"
            justify="center"
            class="dashboard-links"
        >
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    class="mx-auto"
                    color="primary"
                    dark
                    flat
                    tile
                    to="/unassigned"
                >
                    <v-card-text>
                        <div class="white--text">Unassigned Leads</div>
                        <p class="display-1 white--text">
                            {{ newCount }}
                        </p>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            text
                            color="white"
                        >
                            View All
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    class="mx-auto"
                    color="primary"
                    dark
                    flat
                    tile
                    to="/leads"
                >
                    <v-card-text>
                        <div class="white--text">All Leads</div>
                        <p class="display-1 white--text">
                            {{ totalCount }}
                        </p>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            text
                            color="white"
                        >
                            View All
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                
            >
                <v-card
                    color="primary"
                    dark
                    to="/myleads"
                    flat
                    tile
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            large
                            left
                        >
                            mdi-calendar-month
                        </v-icon>
                        <span class="subtitle-1 font-weight-light">My Leads</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    color="primary"
                    dark
                    to="/new"
                    flat
                    tile
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            large
                            left
                        >
                            mdi-playlist-plus
                        </v-icon>
                        <span class="subtitle-1 font-weight-light">Add New Lead</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    color="primary"
                    dark
                    @click.stop="calToggle = !calToggle"
                    flat
                    tile
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            large
                            left
                        >
                            mdi-calculator
                        </v-icon>
                        <span class="subtitle-1 font-weight-light">Quote Calculator</span>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    color="primary"
                    dark
                    flat
                    tile
                    @click.stop="profileToggle = !profileToggle"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            large
                            left
                        >
                            mdi-account
                        </v-icon>
                        <span class="subtitle-1 font-weight-light">Account Settings</span>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data: () => ({
            dialog: false,
            notifications: false,
            sound: true,
            widgets: false,
        }),
        mounted() {
            this.getData()
        },
        computed: {
            ...mapGetters({
                newCount: 'data/newCount',
                totalCount: 'data/allCount',
                calculator: 'menu/calculatorDialog',
                profile: 'menu/profileDialog'
            }),
            calToggle: {
                get() {
                    return this.calculator
                },
                set(newValue) {
                    this.$store.commit('menu/SET_CAL_DIALOG', newValue)
                }
            },
            profileToggle: {
                get() {
                    return this.profile
                },
                set(newValue) {
                    this.$store.commit('menu/SET_PROFILE_DIALOG', newValue)
                }
            },
        },
        methods: {
            ...mapActions({
                getData: 'data/getData'
            })
        }
    }
</script>

<style lang="sass">
.dashboard-links
    padding: 4px
    
    .col-6
        padding: 4px

        .v-card 
            min-height: calc((100vh - 96px) / 3)
            display: flex
            flex-wrap: wrap
            align-content: center
</style>